module.exports = __webpack_public_path__ + "img/Weapon_212.c8255a23.png";